<div *ngIf="isLoading" class="detail-loading-container">
  <div class="loading-spinner">
    <app-loading></app-loading>
  </div>
</div>

<div class="detail-container" *ngIf="anime">
  <ng-container *ngIf="!isLoading">
    <div class="left-side">
      <div class="anime-cover">
        <img class="detail-anime-cover" alt="poster" src={{anime.coverImage.extraLarge}}>
      </div>
      <div *ngIf="anime.status" class="type">
        <label class="mini-info">Status:</label> {{anime.status}}
      </div>
      <div *ngIf="anime.endDate" class="anime-finished">
        <label class="mini-info">Finished:</label> {{animeDetailService.getMonthAsText(anime.endDate.month)}} {{anime.endDate.day ?
        anime.endDate.day
        +'th' : ''}}
        {{anime.endDate.year}}
      </div>
      <div *ngIf="anime.type" class="type">
        <span>
          <label class="mini-info">Type:</label> {{anime.type}}
        </span>
      </div>
      <div *ngIf="anime.episodes" class="anime-episodes">
        <span>
          <label class="mini-info">Episodes:</label> {{anime.episodes}}
        </span>
      </div>
      <div *ngIf="anime.volumes" class="anime-volumes">
        <span>
          <label class="mini-info">Volumes:</label> {{anime.volumes}}
        </span>
      </div>
      <div *ngIf="anime.studios.nodes && anime.studios.nodes.length > 0" class="anime-studio">
        <span>
          <label class="mini-info">Studios:</label> {{animeDetailService.getAnimeStudiosName(anime.studios)}}
        </span>
      </div>
      <div class="anime-running-date">
        <span>
          <label class="mini-info">Air/Release Date:</label>
          {{anime.startDate.month}}/{{anime.startDate.day}}/{{anime.startDate.year}} -
          {{anime.endDate.month}}/{{anime.endDate.day}}/{{anime.endDate.year}}
        </span>
      </div>
      <div *ngIf="anime.genres && anime.genres.length > 0" class="anime-genres">
        <span>
          <label class="mini-info">Genres:</label> {{animeDetailService.getAnimeGenres(anime.genres)}}
        </span>
      </div>
    </div>
  
    <div class="right-side">
      <div class="anime-header">
        <div class="anime-titles">
          <h2>{{anime.title.english}}</h2>
          <h4>{{anime.title.romaji}}</h4>
        </div>
        <div class="anime-rating">
          <b>Rating:</b> {{anime.averageScore}}
        </div>
      </div>
      <div *ngIf="anime.trailer" class="anime-trailer">
        <label><b>Trailer:</b> <a href="javascript:void(0)"
            (click)="animeDetailService.goToTrailerLink(animeDetailService.getAnimeTrailer(anime.trailer))">{{anime.trailer.site}}</a></label>
      </div>
      <div class="anime-summary">
        <p>{{anime.description}}</p>
      </div>
  
  
      <ng-container *ngIf="anime.characters.nodes.length > 0">
        <h2 class="character-title">Characters</h2>
        <div class="anime-characters">
          <div class="character-container" *ngFor="let character of anime.characters.nodes; index as i; first as isFirst">
            <div class="character-img">
              <img class="character-img-poster" alt="poster" src={{character.image.medium}}>
            </div>
            <div class="character-name-container">
              <p class="character-name">{{character.name.full}}</p>
              <p>{{character.age}}</p>
              <p>{{character.gender}}</p>
            </div>
          </div>
        </div>
      </ng-container>
  
      <ng-container *ngIf="animeRecs.length > 0">
        <h2 class="rec-title">Recommendations</h2>
        <div class="anime-recs">
          <div class="recs-container" *ngFor="let rec of animeRecs; index as i; first as isFirst">
            <div class="rec-img">
              <img *ngIf="rec?.coverImage?.medium" (click)="goToAnime(rec.id)" class="rec-img-poster" alt="poster"
                src={{rec.coverImage.medium}}>
            </div>
            <div class="rec-name-container">
              <p *ngIf="rec.title.english; else altTitle" class="rec-name">{{rec.title.english}}</p>
              <ng-template #altTitle>
                <p class="rec-name">{{rec.title.romaji}}</p>
              </ng-template>
            </div>
          </div>
        </div>
      </ng-container>
  
    </div>
  </ng-container>